/**
 * core/ColorManager
 *
 * A class for managing which colors
 * are being used for which keywords.
 */


export default class ColorManager {

    constructor(palette = {}) {
        this.colors = palette;
    }


    /**
     * @param String key
     * @return String
     */
    get(key) {
        if (!(key in this.colors)) {
            this.colors[key] = this._generateColor();
        }

        return this.colors[key];
    }


    /**
     * Taken from the generate-color package. Since this is the only line of
     * code we use from the package, we save ~2kb of dependency.
     *
     * @return String
     */
    _generateColor() {
        let color = '';
        while (color.length !== 6) {
            color = Math.round(16777215 * Math.random()).toString(16);
        }

        return `#${color}`;
    }

}
